// CREATE
export const ADD_SIGNUP_REQUEST = "ADD_SIGNUP_REQUEST";
export const ADD_SIGNUP_SUCCEED = "ADD_SIGNUP_SUCCEED";
export const SIGNUP_FAILED = "SIGNUP_FAILED";

// LOGIN
export const GET_SIGNIN_REQUEST = "GET_SIGNIN_REQUEST";
export const GET_SIGNIN_SUCCEED = "GET_SIGNIN_SUCCEED";

// SIGN OUT
export const GET_SIGNOUT_REQUEST = "GET_SIGNOUT_REQUEST";
export const GET_SIGNOUT_SUCCEED = "GET_SIGNOUT_SUCCEED";

// MESSAGE
export const SHOW_MESSAGE = "SHOW_MESSAGE";

// GET
export const GET_USER_SUCCEED = "user/get/succeed";
export const GET_USER_REQUEST = "user/get/request";
export const GET_USER_FAILED = "user/get/failed";

// GET BY RUMAH TAHFIDZ
export const GET_BY_RUMAHTAHFIDZ_USER_REQUEST = "user/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_USER_SUCCEED = "user/getrumahtahfidz/succed";
export const GET_BY_RUMAHTAHFIDZ_USER_FAILED = "user/getrumahtahfidz/failed";

// GET BY MASTER TAHFIDZ
export const GET_BY_MASTERTAHFIDZ_USER_REQUEST =
  "user/getmastertahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_USER_SUCCEED =
  "user/getmastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_USER_FAILED = "user/getmastertahfidz/failed";

// GET BY ADMIN
export const GET_BY_ADMIN_USER_REQUEST = "user/getbyadmin/succeed";
export const GET_BY_ADMIN_USER_SUCCEED = "user/getbyadmin/request";
export const GET_BY_ADMIN_USER_FAILED = "user/getbyadmin/failed";

export const CREATE_USER_REQUEST = "user/create/request";
export const CREATE_USER_SUCCEED = "user/create/succeed";
export const CREATE_USER_FAILED = "user/create/failed";

export const CREATE_USERSANTRI_REQUEST = "user/createusersantri/request";
export const CREATE_USERSANTRI_SUCCEED = "user/createusersantri/succeed";
export const CREATE_USERSANTRI_FAILED = "user/createusersantri/failed";

export const CREATE_USER_NOFILE_REQUEST = "user/createnofile/request";
export const CREATE_USER_NOFILE_SUCCEED = "user/createnofile/succeed";
export const CREATE_USER_NOFILE_FAILED = "user/createnofile/failed";

export const CREATE_USERSANTRI_NOFILE_REQUEST =
  "user/createusersantrinofile/request";
export const CREATE_USERSANTRI_NOFILE_SUCCEED =
  "user/createusersantrinofile/succeed";
export const CREATE_USERSANTRI_NOFILE_FAILED =
  "user/createusersantrinofile/failed";

export const DELETE_USER_REQUEST = "user/delete/request";
export const DELETE_USER_SUCCEED = "user/delete/succeed";
export const DELETE_USER_FAILED = "user/delete/failed";

export const GET_BY_ID_USER_REQUEST = "user/getid/request";
export const GET_BY_ID_USER_SUCCEED = "user/getid/succeed";
export const GET_BY_ID_USER_FAILED = "user/getid/failed";

export const UPDATE_USER_REQUEST = "user/update/request";
export const UPDATE_USER_SUCCEED = "user/update/succeed";
export const UPDATE_USER_FAILED = "user/update/failed";

export const UPDATE_USER_NOFILE_REQUEST = "user/updatenofile/request";
export const UPDATE_USER_NOFILE_SUCCEED = "user/updatenofile/succeed";
export const UPDATE_USER_NOFILE_FAILED = "user/updatenofile/failed";

export const UPDATE_USER_NOFILE_USERSANTRI_REQUEST =
  "user/updatenofileusersantri/request";
export const UPDATE_USER_NOFILE_USERSANTRI_SUCCEED =
  "user/updatenofileusersantri/succeed";
export const UPDATE_USER_NOFILE_USERSANTRI_FAILED =
  "user/updatenofileusersantri/failed";
